import { render, staticRenderFns } from "./ModalRefillBalance.vue?vue&type=template&id=4b052f0a&scoped=true&"
import script from "./ModalRefillBalance.vue?vue&type=script&lang=ts&"
export * from "./ModalRefillBalance.vue?vue&type=script&lang=ts&"
import style0 from "./ModalRefillBalance.vue?vue&type=style&index=0&id=4b052f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b052f0a",
  null
  
)

export default component.exports